import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { TFunction } from 'i18next'
import * as React from 'react'
import { withTranslation } from 'react-i18next'
import SignInApp from '../app/signInApp'
import LoginComponent from '../signIn'
import closeMenuIcon from './../../assets/images/close.svg'
import { styles } from './styles'

interface SignInModalProps {
  handleClose: any
  openStatus: boolean
  loggedInUserInfo?: any
  t: TFunction
  allowRedirect?: boolean
}

const SignInModal = ({
  handleClose,
  openStatus,
  t,
  allowRedirect = true,
}: SignInModalProps) => {
  const classes = styles()
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const urlParams = new URLSearchParams(window.location.search)
  let isFromIos = urlParams.get('ios')
  isFromIos = null

  return isFromIos ? (
    <SignInApp handleClose={handleClose} openStatus={openStatus} />
  ) : (
    <Dialog
      fullScreen={fullScreen}
      open={openStatus}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <section className={classes.dialogContainer}>
        <DialogTitle
          id="responsive-dialog-title"
          className={classes.dialogTitleSection}
        >
          <button onClick={handleClose} className={classes.closeButton}>
            <img src={closeMenuIcon} alt={t('imageAlts.close')} />
          </button>
        </DialogTitle>
        <LoginComponent allowRedirect={allowRedirect} />
      </section>
    </Dialog>
  )
}

export default withTranslation()(SignInModal)
